module.exports = __webpack_public_path__ + "static/media/racetrack.1e05221a.png";